import { styled } from "./styles";

/**
 * EN-5191: fills the app area while the published translations for a non-English session are
 * still in flight. Sized to the viewport so the spinner sits where the user is already looking
 * rather than jumping the layout when the real content replaces it.
 */
export const LanguageLoadingContainer = styled("div", {
  width: "100%",
  height: "100vh",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
